import { Controller } from '@hotwired/stimulus';
import { get } from '@rails/request.js';
import { hide as hideElement, show as showElement } from '@frontend/utils/dom';
import { dispatchCustomEvent } from '@frontend/utils/events';
import Keyboard from '@frontend/utils/keyboard';

export default class extends Controller {
  static targets = ['overlay', 'window', 'body'];
  static values = {
    isFocused: { type: Boolean, default: false },
    confirmClose: { type: Boolean, default: false },
  };

  connect() {
    document.body.addEventListener(
      'modal-window:display',
      this.handleDisplay.bind(this)
    );
    document.body.addEventListener(
      'modal-window:load-and-display',
      this.loadAndDisplayUrl.bind(this)
    );
    document.body.addEventListener('modal-window:hide', this.hide.bind(this));

    Keyboard.map('escape', (event) => {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      this.hide();
    });
  }

  display(html) {
    this.bodyTarget.innerHTML = html;
    if (html === null) {
      hideElement(this.windowTarget);
    } else {
      showElement(this.windowTarget);
    }
    this.disableBackgroundScrolling();
    showElement(this.overlayTarget);
    this.isFocusedValue = true;
  }

  isFocusedValueChanged() {
    if(this.isFocusedValue) {
      this.previouslyActiveElement = document.activeElement;
      this.bodyTarget.focus();
      this.overlayTarget.addEventListener('keydown', this.handleKeyUpOnOverlay.bind(this));
    } else {
      if (this.previouslyActiveElement) {
        this.previouslyActiveElement.focus();
        this.previouslyActiveElement = null;
      }
      this.overlayTarget.removeEventListener('keydown', this.handleKeyUpOnOverlay.bind(this));
    }
  }

  handleKeyUpOnOverlay(event) {
    if(event.code === 'Escape') {
      event.stopPropagation()
      this.hide();
    }
  }

  hide() {
    if(this.confirmCloseValue === false) {
      this._hide();
    } else {
      if(window.confirm("Bist du sicher?")) {
        this._hide();
      }
    }
  }

  _hide() {
    this.reEnableBackgroundScrolling();
    hideElement(this.overlayTarget);
    this.bodyTarget.innerHTML = '';
    this.isFocusedValue = false;
  }

  async loadAndDisplay(url, confirmClose = false) {
    const response = await get(url);
    if (response.ok) {
      const html = await response.text;
      this.display(html);
      this.confirmCloseValue = confirmClose;
    }
  }

  disableBackgroundScrolling() {
    document.querySelector('html').classList.add('prevent-scroll');
  }

  reEnableBackgroundScrolling() {
    document.querySelector('html').classList.remove('prevent-scroll');
  }

  loadAndDisplayUrl(event) {
    const url = event.params?.url || event.detail?.url;
    const confirmClose = event.params?.confirmClose || event.detail?.confirmClose;
    this.loadAndDisplay(url, confirmClose);
  }

  handleDisplay({ detail: { html } }) {
    this.display(html);
  }
}

export function display(html) {
  dispatchCustomEvent('modal-window:display', { html });
}

export function loadAndDisplay(url, confirmClose) {
  dispatchCustomEvent('modal-window:load-and-display', { url, confirmClose });
}

export function hide() {
  dispatchCustomEvent('modal-window:hide');
}
